module.exports = __webpack_public_path__ + "static/media/yzm_bg_03.53334481.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/yzm_bg_03.png
// module id = 1878
// module chunks = 0 1